import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextDiaT1 = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Type 1 diabetes is an autoimmune disorder in which the body attacks its pancreatic beta cells. 
If you have type 1 diabetes, your pancreas doesn’t make insulin or makes very little insulin. Insulin helps blood sugar enter the cells in your body for use as energy. 
Without insulin, blood sugar can’t get into cells and builds up in the bloodstream. High blood sugar is damaging to the body and causes many of the symptoms and complications of diabetes.
<br /> <br /> 
Type 1 diabetes is thought to be caused by an autoimmune reaction (the body attacks itself by mistake). 
This reaction destroys the cells in the pancreas that make insulin, called beta cells. This process can go on for months or years before any symptoms appear.

Some people have certain genes (traits passed on from parent to child) that make them more likely to develop type 1 diabetes. 
However, many of them won’t go on to have type 1 diabetes even if they have the genes.
 A trigger in the environment, such as a virus, may also play a part in developing type 1 diabetes. Diet and lifestyle habits don’t cause type 1 diabetes.
 <br /> <br /> 
 There is often a family history of T1D, however the majority of diagnoses occur in people who have no family members with the disease. 
 Nonetheless, having a family history of T1D puts people at higher risk of developing the disease. Gestational diabetes and type 2 diabetes (T2D) are not indicators of a familial disposition for T1D.


<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
'HLA-DR', 'HLA-DR2', 'HLA-DR3', 'HLA-DR4' 'HLA-DQ', 'HLA-DP', 'DQB1', 'DRB1', 'ZFM1', 'FADD', 'FAS', 'LRP5', 'SOD2', 'DCC', 'ZNF236', 'NEUROD1', 'MODY6', 'IGRP', 'GAD', 'GAD2',
 'GABA', 'KIR', 'ABCC8', 'SEL1L', 'CTLA4', 'CD28', 'ICOS', 'ILB12'      
 
<br /><br /> 
 
</Typography>

</div>
)
}